import { useContext, useEffect, useRef } from 'react';
import { useLocation } from 'react-router-dom';
import { UserContext } from '../contexts/UserContext';
import { postNavigationActivity } from '../utility-services/navigationTrackingService';

const NavigationActivityTracker = () => {
    const location = useLocation();
    const { user, faciToken, userLoading } = useContext(UserContext);
    const lastTrackedPathRef = useRef('');
    const hasTrackedLoginEventRef = useRef(false);

    useEffect(() => {
        if (!faciToken) {
            hasTrackedLoginEventRef.current = false;
            lastTrackedPathRef.current = '';
            return;
        }

        if (userLoading || !faciToken) return;

        const currentPath = location.pathname;
        if (!currentPath || currentPath === lastTrackedPathRef.current) return;

        const isLoginEvent = !hasTrackedLoginEventRef.current;
        lastTrackedPathRef.current = currentPath;
        hasTrackedLoginEventRef.current = true;
        postNavigationActivity({
            user,
            pathname: currentPath,
            actionType: isLoginEvent ? 'login' : 'navigation',
            actionDetails: currentPath,
        });
    }, [faciToken, location.pathname, user, userLoading]);

    return null;
};

export default NavigationActivityTracker;

